import { Button, Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import login from "../../api/auth/login";
import WushTextField from "../../components/form/WushTextField";
import useAuthStore from "../../stores/useAuthStore";

export default function Landing() {
  const { setUser, setLoggedIn, setToken, setLoginError, setOrganization, setIsAdmin } = useAuthStore();
  const { register, handleSubmit } = useForm();

  const onSubmit = (values) => {
    login(values.email, values.password, (response, headers) => {
      console.log(headers);
      setLoginError(false);
      setLoggedIn(true);
      setToken(headers.authorization);
      setUser(response);
      setOrganization(response.organization);
      setIsAdmin(response.account_type === 'admin' || response.account_type === 'shared_admin');
      window.location = "/";
    });
  };

  return (
    <Stack>
      <Stack justifyContent="center">
        <Stack px={{ xs: "10%", sm: "25%" }} py={"10%"} justifyContent={{ xs: 'center', sm: 'left' }}>
          <Stack>
            <Typography variant="h1">
              Wush <em>Inventory</em>
            </Typography>
          </Stack>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Stack mb={2}>
              <WushTextField formRegistration={register("email")} label="Email" />
            </Stack>
            <Stack mb={2}>
              <WushTextField type="password" formRegistration={register("password")} label="Password" />
            </Stack>
            <Stack>
              <Button sx={{ width: "220px" }} type="submit" variant="contained" color="primary">
                Login
              </Button>
            </Stack>
          </form>
        </Stack>
      </Stack>
    </Stack>
  );
}